import generateCustomColorMarker from '~/utils/generate_custom_color_marker';

export default {
  methods: {
    generateCustomColorMarker,
  },
};
